<template>
  <div class="cost_warp">
    <div class="info_item"> 
      <div class="info_item_row">
        费用明细
      </div>
    </div>
    <div class="info_item"> 
      <div class="info_item_row">
        套餐价格：1400
      </div>
    </div>
    <div class="info_item"> 
      <div class="info_item_row">
        订单金额：￥1400  
      </div>
      <div class="info_item_row">
        <!-- <el-button type="danger">去付款</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
$border_bottom: 2px dotted #ddd;
.cost_warp{
  width: 100%;
  min-height: 100px;
  border:1px solid red;
  margin: 10px 0;
  padding: 0 15px;
  font-size: 18px;
  .info_item {
    margin: 10px 0;
    padding: 10px 0;
    border-bottom: $border_bottom;
    display: flex;
    flex-direction: column;
    .info_item_row {
      display: flex;
      align-items: center;
      padding: 5px 0;
      .info_label {
        font-size: 16px;
        font-weight: 600;
        min-width: 100px;
      }
      span {
        margin: 0 5px;
      }
    }
  }
}
</style>
